<template>
  <div>
    <div class="d-flex justify-center">
      <div class="_60_w" v-if="!loading && section && isReady">
        <v-card class="rounded_max" elevation="1" style="overflow: hidden">
          <div class="strip" :style="`background:${section.color}`"></div>
          <div class="d-flex justify-space-between px-2">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  :to="`/section/inclass/${$route.params.idSection}/${$route.params.idCourse}`"
                  icon
                  ><v-icon>mdi-reply</v-icon></v-btn
                >
              </template>
              <span>Back</span>
            </v-tooltip>
          </div>
          <div class="px-5 pb-5" v-if="module">
            <h3>{{ module.title }}</h3>
            <p class="mb-0 mt-2" v-html="module.description"></p>
          </div>
        </v-card>

        <div class="mt-3" v-if="answered == 0">
          <div v-if="!loadQuest">
            <v-card
              class="rounded_max mb-3"
              v-for="(quiz, i) in dataSet.data"
              :key="`quin-in-${i}`"
              elevation="1"
            >
              <div class="px-5 pb-3 pt-2">
                <h4>{{ quiz.number }}. {{ quiz.question }}</h4>
                <div v-if="quiz.type == 'multiple'">
                  <v-radio-group class="pa-0 mt-2" v-model="quiz.opini">
                    <v-radio
                      @click="pickAnswer(quiz.id, quiz.opini)"
                      v-for="(opt, n) in quiz.choice"
                      :color="section.color"
                      :key="`opt-${n}`"
                      :value="opt.index"
                      :label="opt.jawaban"
                    ></v-radio>
                  </v-radio-group>
                </div>
                <div v-else>
                  <v-text-field
                    placeholder="Type Here"
                    v-model="quiz.opini"
                    :color="section.color"
                    @blur="pickAnswer(quiz.id, quiz.opini)"
                  ></v-text-field>
                </div>
              </div>
            </v-card>
          </div>
          <div v-else>
            <div>
              <v-skeleton-loader
                v-for="i in 2"
                :key="i"
                type="image"
                class="rounded_lg mb-2"
                height="150px"
              ></v-skeleton-loader>
            </div>
          </div>
          <div class="d-flex justify-center">
            <v-btn
              class="mr-3"
              @click="paginate('prev')"
              :color="section.color"
              dark
              fab
              small
              depressed
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
            <v-btn
              :color="section.color"
              @click="paginate('next')"
              dark
              fab
              small
              depressed
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card
          class="rounded_max mt-3 pb-3"
          elevation="1"
          v-if="answered == 1"
        >
          <div
            class="d-flex align-center justify-center flex-column"
            style="height: 100%"
          >
            <img
              src="../../../../assets/img/gundam/LMS Aset Illustration Jawaban Tersimpan.png"
              height="150px"
              alt=""
            />
            <h3>Your answer has been saved</h3>
          </div>
        </v-card>
      </div>
      <div
        v-if="!isReady && !loading"
        class="d-flex flex-column align-center justfiy-center"
      >
        <img
          src="../../../../assets/img/Halaman Unauthorized.png"
          height="300px"
          alt=""
        />
        <h3 class="mt-2">Module not ready</h3>
        <p class="default_txt">
          The module is being prepared by the administrator
        </p>
        <v-btn
          depressed
          dark
          class="mt-2"
          @click="$router.go(-1)"
          :color="section.color"
          >back</v-btn
        >
      </div>
      <div v-if="loading" class="_60_w">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="pa-3">
              <v-skeleton-loader
                type="image"
                class="rounded_lg"
                height="230px"
              ></v-skeleton-loader>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!-- CREATE QUIZ -->
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchModule"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import DialogMedium from "../../../dialog/dialogMedium.vue";
import DialogSmall from "../../../dialog/dialogSmall.vue";
export default {
  components: {
    // DialogMedium,
    DialogSmall,
  },
  computed: {
    ...mapState({
      id: (state) => state.id,
    }),
  },
  name: "moduleQuiz",
  data() {
    return {
      loadQuest: false,
      loading: true,
      dataSet: null,
      section: null,
      module: null,
      drag: false,
      answer: [],
      sorting: false,
      msg: "",
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      page: 1,
      limit: 5,
      total: null,
      last_page: null,
      isNext: "",
      isPrev: "",
      answered: null,
      id_test: null,
      isReady: false,
    };
  },
  computed: {},
  mounted() {
    this.id_test = this.$route.params.idInstance;
    let answer = JSON.parse(localStorage.getItem(`q_answer_${this.id_test}`));
    if (answer) {
      this.answer = answer;
    }
    this.fetchSection();
    this.fetchModule();
  },
  methods: {
    fetchSection() {
      this.loading = true;
      let data = {
        path: `manage/course/section?filter[id]=${this.$route.params.idSection}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.section = data.data[0];
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchModule() {
      let module = this.$route.params.idModule;
      let instance = this.$route.params.idInstance;
      this.loading = true;
      let data = {
        path: `scholar/course/section/module/${module}/${instance}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          this.loading = false;
          this.module = data.data;
          this.answered = data.is_tes;
          if (this.answered == 0) {
            this.fetchData(true);
          } else {
            this.isReady = true;
          }
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    paginate(state) {
      if (state == "next") {
        if (this.isNext) {
          this.page++;
          this.fetchData();
        } else {
          this.finish();
        }
      } else if (state == "prev") {
        if (this.isPrev) {
          this.page--;
          this.fetchData();
        }
      }
    },
    fetchData() {
      let instance = this.$route.params.idInstance;

      this.loadQuest = true;
      let data = {
        path: `scholar/course/section/module/quiz/get/${instance}?page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("course/getData", data)
        .then((data) => {
          data.data.forEach((el) => {
            if (this.answer.length) {
              this.answer.forEach((x) => {
                if (el.id == x.no) {
                  el["opini"] = x.val;
                }
              });
            } else {
              el["opini"] = "";
            }
          });
          this.total = data.total;
          this.last_page = data.last_page;
          if (data.data.length) {
            this.isReady = true;
            this.dataSet = data;
            this.isNext = data.next_page_url;
            this.isPrev = data.prev_page_url;
          }
          this.loadQuest = false;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    pickAnswer(no, val) {
      let idx = null;
      let exist = this.answer.find((x) => {
        return x.no == no;
      });
      if (exist) {
        idx = this.answer.findIndex((el) => el.no === no);
        this.answer[idx].val = val;
      } else {
        this.answer.push({
          no: no,
          val: val,
        });
      }
      localStorage.setItem(
        `q_answer_${this.id_test}`,
        JSON.stringify(this.answer)
      );
    },

    finish() {
      let opini = JSON.parse(localStorage.getItem(`q_answer_${this.id_test}`));
      let answer = {};
      opini.forEach((el) => {
        answer[el.no] = el.val;
      });
      this.d_type = "s_quiz";
      this.d_title = "";
      this.inventory = answer;
      this.d_small = true;
    },
  },
};
</script>

<style scoped>
.strip {
  padding: 3px;
  height: 10px;
  width: 100%;
  border-radius: 0 !important;
}
</style>
